module.exports = __webpack_public_path__ + "Bliss2-MediumItalic.72507d9c8ae02b058333.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/Bliss2-MediumItalic.woff
// module id = ../../../../../src/assets/layout/fonts/Bliss2-MediumItalic.woff
// module chunks = styles